import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    popup: {
      open: false,
      content: ''
    },

    message: {
      open: false,
      type: '',
      message: ''
    },

    booking: {
      temp_id: null,
      vehiclecategoryid: null,
      pickuplocationid: '',
      pickupdate: new Date(),
      pickuptime: '08:00',
      dropofflocationid: '',
      dropoffdate: new Date(),
      dropofftime: '08:00',
      ageid: 9,
      vehiclecategorytypeid: "0",
      campaigncode: '',
      return: false,
      vehicle: {},
      insurance_extras: [],
      totals: {},
      requesttype: 'book',
      isRequest: false,
      customer: {
        firstname: '',
        lastname: '',
        email: '',
        email_confirm: '',
        phone: '',
        dateofbirth: '',
        dob_day: '',
        dob_month: '',
        dob_year: '',
        country: '',
        additional_details: '',
        found_by: '',
        address: '',
        city: '',
        state: '',
        postcode: '',
        countryid: '',
        licenseno: '',
        licenseissued: '',
        licenseexpires: '',
        expiry_day: '',
        expiry_month: '',
        expiry_year: '',
      },
      numbertravelling: '',
      remark: '',
      transmission: '',
      foundusid: '',
      flightin: '',
    },

    confirmation: {
      is_quote: false,
      booking_result: {},
      analytics: {},
    },

    short_form: true,

    cart: {
      total: 0,
      subtotal: 0,
      insurance: 0,
      gst: 0,
      optionals: []
    },

    totals: {
      total: 0,
      subtotal: 0,
      insurance: 0,
      gst: 0,
      optionals: []
    },

    notice: true,

    vehicles: [],
    insuranceOptions: [],
    locations: [],

    steps: [
      { step: 1, title: 'Choose Your Dates', completed: true, slug: '/booking' },
      { step: 2, title: 'Select Your Vehicle', completed: false, slug: '/booking/select-your-vehicle' },
      { step: 3, title: 'Pick Your Insurance', completed: false, slug: '/booking/pick-insurance' },
      { step: 4, title: 'Provide Your Details', completed: false, slug: '/booking/provide-details' },
      { step: 5, title: 'Pay & Confirm', completed: false, slug: '/booking/confirmation' }
    ],

    iFrameSrc: null,
    reservationref: null,
    isTermsAccepted: false,
    isOffersAccepted: true,

    googleAddressFields: {
      isAddressManual: true,
      address: '',
    },
  },
  mutations: {
    setGoogleAddressFields (state, data) {
      state.googleAddressFields.isAddressManual = data.isAddressManual
      state.googleAddressFields.address = data.address
    },

    setTerms (state, data) {
      state.isTermsAccepted = data
    },

    setOffers (state, data) {
      state.isOffersAccepted = data
    },

    setReservationRef (state, data) {
      state.reservationref = data
    },

    setIFrameSrc (state, data) {
      state.iFrameSrc = data
    },

    setPopup (state, data) {
      state.popup = data
    },

    setToastMessage (state, data) {
      state.message = data
    },

    setNotice (state, bool) {
      // only close if mobile-width version
      state.notice = bool
    },

    setBooking (state, form) {
      state.booking = form
    },

    setQuote (state, data) {
      state.booking.requesttype = data
    },

    setVehicles (state, vehicles) {
      state.vehicles = vehicles
    },

    setInsuranceOptions (state, insuranceOptions) {
      state.insuranceOptions = insuranceOptions
    },

    setCart (state, form) {
      state.cart = form
    },

    setLocations(state, data) {
      state.locations = data
    },

    setTotals(state, data) {
      state.totals = data
    },

    updateSteps (state) {
      if (state.booking.vehicle) {
        state.steps[1].completed = true
      }
    },

    updateFourthStep (state, data) {
      state.steps[3].completed = data
    },

    updateAllSteps (state, data) {
      state.steps = data
    },

    setConfirmation (state, data) {
      state.confirmation = data
    },

    setShortForm (state, data) {
      state.short_form = data
    },

    setTempId (state) {
      if (state.booking.temp_id === null) {
        const timestamp = Date.now();
        const randomString = Math.random().toString(36).substring(7); // Random alphanumeric string
        state.booking.temp_id = timestamp + '-' + randomString;
      }

    },

    updateCompletedStatus(state) {
      for (let i = 0; i < state.steps.length; i++) {
        if (i !== 0 || i !== 4)
        state.steps[i].completed = false
        console.log('steps', state.steps)
      }
    },

    resetBookingValues (state) {
      state.booking =  {
        temp_id: null,
        vehiclecategoryid: null,
        pickuplocationid: '',
        pickupdate: new Date(),
        pickuptime: '08:00',
        dropofflocationid: '',
        dropoffdate: new Date(),
        dropofftime: '08:00',
        ageid: 9,
        vehiclecategorytypeid: "0",
        campaigncode: '',
        return: false,
        extrakmsid: 0,
        vehicle: {},
        insurance_extras: [],
        totals: {},
        requesttype: 'book',
        customer: {
          firstname: '',
          lastname: '',
          email: '',
          email_confirm: '',
          phone: '',
          dateofbirth: '',
          dob_day: '',
          dob_month: '',
          dob_year: '',
          country: '',
          additional_details: '',
          found_by: '',
          address: '',
          city: '',
          state: '',
          postcode: '',
          countryid: '',
          licenseno: '',
          licenseissued: '',
          licenseexpires: '',
          expiry_day: '',
          expiry_month: '',
          expiry_year: '',
        },
        numbertravelling: '',
        remark: '',
        transmission: '',
        foundusid: '',
        flightin: '',
      }
    },

  },
  getters: {},
  actions: {
    updateBookingVehicle({ commit }, booking) {
      commit('setBooking', booking)

      commit('setTerms', true)
      commit('setOffers', true)
      commit('updateSteps')
    },

    updateTotals({ commit }, data) {
      commit('setTotals', data)
    },

    updateInsuranceOptions({ commit }, insuranceOptions) {
      commit('setInsuranceOptions', insuranceOptions)
    }
  }
})
